import React from "react";
import { NotAvailable } from "lib/SimpleTable";
import ErrorBoundary from "lib/ErrorBoundary";
import { ViewLayoutRedesign } from "./viewLayout/ViewLayoutRedesign";
import { useJSFetchPublications } from "./publications/api/direct/useJSFetchPublications";
import { useCreateSearchRequest } from "./publications/api/searchRequest/useCreateSearchRequest";
import { SectorSubSectorDataProvider } from "./viewLayout/sidePanel/sectorSubSectorDataProvider";
import "./redesign_dict_ja";

function Redesign() {
  const searchRequest = useCreateSearchRequest();
  const searchResults = useJSFetchPublications(searchRequest);
  const error = searchResults?.[2];

  if (error) return <NotAvailable />;

  return (
    <ErrorBoundary>
      <SectorSubSectorDataProvider>
        <ViewLayoutRedesign searchResults={searchResults} />
      </SectorSubSectorDataProvider>
    </ErrorBoundary>
  );
}

export default Redesign; // must be a default export for code splitting
